var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicableActionsNotStranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00262046 0.872712C0.0403274 0.340584 0.475127 -0.0479925 0.973774 0.00480197C0.973774 0.00480197 7.12613 0.656185 11.0683 1.07356C15.0104 1.49094 21.1628 2.14232 21.1628 2.14232C21.6614 2.19512 22.0351 2.66929 21.9974 3.20142C21.9597 3.73355 21.5249 4.12212 21.0262 4.06933C21.0262 4.06933 14.8739 3.41795 10.9317 3.00057C6.98958 2.58319 0.837225 1.93181 0.837225 1.93181C0.338579 1.87901 -0.0350865 1.40484 0.00262046 0.872712Z",
    fill: "#204BE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.85458L0.973774 7.0048C0.475128 6.95201 0.0403274 7.34058 0.00262046 7.87271C-0.0350865 8.40484 0.338579 8.87901 0.837225 8.93181L9 9.79605V7.85458Z",
    fill: "#D1C022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.2195L21.0262 11.0693C21.5249 11.1221 21.9597 10.7335 21.9974 10.2014C22.0351 9.66929 21.6614 9.19512 21.1628 9.14232L13 8.27808V10.2195Z",
    fill: "#D1C022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicableActionsNotStranding);
export default __webpack_public_path__ + "static/media/applicable-actions-not-stranding.572c6d2e9e09033b7ecb823fb29508db.svg";
export { ForwardRef as ReactComponent };